import { useEffect } from "react";
import PropTypes from "prop-types";
import useAuth from "app/hooks/useAuth";
import { syncHealthcareUiSession } from "lab-catalog-shell/auth/sessionStore";

/** Mirrors JWTAuthContext user into the catalog zustand slice (appsCode, permissions). */
export default function LabCatalogAuthBridge({ children }) {
  const { user } = useAuth();

  useEffect(() => {
    syncHealthcareUiSession(user ?? null);
  }, [user]);

  return children;
}

LabCatalogAuthBridge.propTypes = {
  children: PropTypes.node,
};
